<template>
  <div>
    <section-title>{{ $t("project-service-title") }}</section-title>

    <b-card class="mb-3 shadow project-service-card">
      <p v-html="$t('project-service-description')"></p>
      <div slot="footer" class="mr-1">
        <b-btn
          variant="primary"
          size="sm"
          class="download-button mr-2"
          :disabled="projectData.isDownloading"
          @click="downloadProject"
        >
          <svgicon icon="download" class="mr-1"></svgicon>
          <span v-if="!projectData.isDownloading">{{
            $t("documents-download-btn")
          }}</span>
          <span v-else>Chargement...</span>
        </b-btn>

        <b-btn
          variant="primary"
          size="sm"
          class="feedback-button"
          @click="openFeedbackModal"
        >
          <svgicon icon="play" class="mr-1"></svgicon>
          {{ $t("feedback-btn") }}
        </b-btn>
      </div>
    </b-card>

    <feedback-modal
      ref="feedbackModal"
      :project-file-name="projectData.fileName"
    />
  </div>
</template>

<script>
import axiosVita from "../../../axiosVita.js";
import FeedbackModal from "./FeedbackModal.vue";
import SectionTitle from "../../SectionTitle.vue";
import ClientService from "../../../services/client.js";

export default {
  components: { SectionTitle, FeedbackModal },
  data() {
    return {
      projectData: {
        fileName: "Projet de service",
        isDownloading: false,
        department: null
      }
    };
  },
  methods: {
    openFeedbackModal() {
      this.$refs.feedbackModal.open();
    },
    async downloadProject() {
      try {
        this.projectData.isDownloading = true;
        // 🛑 1. RÉCUPÉRER LES COORDONNÉES CLIENT POUR OBTENIR LE CODE POSTAL
        const clientResponse = await ClientService.get();
        const clientData = clientResponse.data;
        const zipCode = clientData.zipCode; // '75001' par exemple

        // 2. EXTRAIRE LE CODE DÉPARTEMENTAL (les 2 premiers chiffres)
        const departmentCode = String(zipCode)
          .substring(0, 2)
          .padStart(2, "0");

        //  TRACKING GA4 — DOWNLOAD
        if (this.$gtag) {
          this.$gtag.event("projet_service_download", {
            client_id: clientData.clientId || null,
            department: departmentCode,
            date: new Date().toISOString()
          });
        }
        // 1️⃣ Appel du middleware Node.js en utilisant axiosVita
        const response = await axiosVita({
          method: "GET",
          url: `/api/client/service-projects/download/${departmentCode}`,
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`
          },
          responseType: "blob"
        });

        if (response.status !== 200) {
          throw new Error("Erreur téléchargement fichier");
        }

        // 2️⃣ Création de l'objet Blob
        // Avec responseType: 'blob', response.data est le Blob directement
        const blob = response.data;
        const url = window.URL.createObjectURL(blob);

        let filename = this.projectData.fileName; // fallback
        const contentDisposition = response.headers["content-disposition"];
        if (contentDisposition) {
          const match = contentDisposition.match(/filename="?([^"]+)"?/);
          if (match && match[1]) {
            filename = match[1];
          }
        }
        if (filename.endsWith(".pdf.pdf")) {
          filename = filename.substring(0, filename.length - 4); // Retire les 4 derniers caractères (.pdf)
        } else if (!filename.endsWith(".pdf")) {
          // S'assurer qu'il y a une extension .pdf
          filename += ".pdf";
        }
        this.projectData.fileName = filename;
        // 4️⃣ Création d'un lien temporaire pour déclencher le téléchargement
        const a = document.createElement("a");
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        a.remove();

        // 5️⃣ Libération de l'objet URL
        setTimeout(() => {
          window.URL.revokeObjectURL(url);
        }, 300);
      } catch (err) {
        console.error(err);
        const errorMessage =
          err.response && err.response.data && err.response.data.message
            ? err.response.data.message
            : "Impossible de télécharger le fichier.";
        this.$bvToast.toast(errorMessage, {
          variant: "danger",
          autoHideDelay: 5000
        });
      } finally {
        this.projectData.isDownloading = false;
      }
    }
  }
};
</script>

<style scoped>
.download-button {
  min-width: 140px;
}
.feedback-button {
  min-width: 120px;
}
</style>
